import module from 'nominas/donaciones/module.js'
import template from './template.html'
import * as moment from 'moment'
import { orderBy } from 'lodash'

export class NominasDonacionesComponent {
  empresa
  nomina
  data
  catalogos
  saving = false
  total = 0
  isValid = false
  exportando = false
  options = {
    ID_Empresa: null,
    ID_Nomina: null,
    Fecha_movimiento: null,
    filter: '',
    showEmpty: true,
  }

  constructor ($filter, $location, NominasDonaciones, $state) {
    this.filterBy = $filter('filter')
    this.$location = $location
    this.NominasDonaciones = NominasDonaciones
    this.$state = $state
  }

  $onChanges (changes) {
    if (changes.data) {
      if (this.data) {
        this.data.Registros = orderBy(this.data.Registros, ['Empresa', 'Empleado'])
      }
      this.options.Fecha_movimiento = this.data ? this.data.Fecha_Final : null
    }

    if (changes.catalogos) {
      this.catalogos.Empresas = orderBy(this.catalogos.Empresas, ['Descripcion'])
      this.catalogos.Nominas = orderBy(this.catalogos.Nominas, ['ID_Nomina'])
    }
  }

  $onInit () {
    this.options.ID_Empresa = this.empresa
    this.options.ID_Nomina = this.nomina
    this.filtrar()
    this.totalizar()
    this.validar()
  }

  filtrar () {
    this.resultados = this.data ? [...this.data.Registros] : []

    if (!this.options.showEmpty) {
      this.resultados = this.resultados.filter((item) => item.Donaciones > 0)
    }

    if (this.options.filter !== '') {
      this.resultados = this.filterBy(this.resultados, {Empleado: this.options.filter})
    }
  }

  totalizar () {
    this.total = this.data ? this.data.Registros.reduce((total, item) => total + item.Donaciones, 0) : 0
  }

  validar () {
    this.isValid = this.data ? this.data.Registros.every((item) => item.Donaciones <= item.Total) : false
  }

  buscar () {
    this.$location.search({
      empresa: this.options.ID_Empresa,
      nomina: this.options.ID_Nomina,
    })
  }

  edit (item) {
    let donacion = prompt('Ingrese el nuevo importe', item.Donaciones)
    if (donacion) {
      item.Donaciones = +donacion
    }
    this.totalizar()
    this.validar()
  }

  save () {
    if (this.saving) return

    this.saving = true

    const data = {
      Fecha_Movimiento: moment(this.data.Fecha_Final).format('YYYY-MM-DD'),
      Notas: `#Donaciones #Charities #${moment(this.data.Fecha_Final).format('YYYYMMDD')} #${this.options.ID_Nomina}`,
      Servicios: this.data.Registros.filter((item) => item.Donaciones > 0)
        .map((item) => ({
          ID_Empleado: item.ID_Empleado,
          ID_Empresa: item.ID_Empresa,
          Importe: item.Donaciones,
        })),
    }

    return this.NominasDonaciones.save(data)
      .then(() => (this.$state.reload()))
      .finally(() => (this.saving = false))
  }
}

module.component('nominasDonaciones', {
  controller: NominasDonacionesComponent,
  template,
  bindings: {
    empresa: '<',
    nomina: '<',
    data: '<',
    catalogos: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/donaciones/components/component.js